{
  "name": "stash-invest-web",
  "version": "6.292.0",
  "private": true,
  "engines": {
    "node": "^24.22.1"
  },
  "scripts": {
    "dev": "vite",
    "start": "vite",
    "start:server": "node --optimize_for_size --max_old_space_size=920 --gc_interval=100 index.js",
    "start:production": "yarn start:server",
    "test": "jest --maxWorkers=50%",
    "test:all": "yarn test && yarn test:server",
    "test:server": "jest --config jest.server.config.json",
    "test:cov": "jest --coverage ",
    "test:debug": "node --inspect-brk node_modules/.bin/jest --runInBand --modulePaths=src",
    "test:report": "npx nyc report --reporter=html && open ./coverage/index.html",
    "build": "vite build",
    "production": "node --optimize_for_size --max_old_space_size=920 --gc_interval=100 index.js",
    "version": "",
    "postversion": "git push && git push --tags",
    "analyze": "source-map-explorer 'build/static/js/*.js'",
    "lint": "eslint src playwright",
    "format": "npx prettier --write 'src/**/**.{js,ts,tsx,css}'",
    "postinstall": "husky install",
    "commit-cli": "cz",
    "playwright:ui:local": "npx playwright test --ui --config=playwright.dev.config.ts",
    "playwright:ui:e2e": "npx playwright test --ui",
    "playwright:local": "yarn playwright test --config=playwright.dev.config.ts",
    "playwright:ts-check": "tsc --noEmit -p playwright/tsconfig.json",
    "bump:sds": "yarn upgrade @stashinvest/react-components @stashinvest/tailwind @stashinvest/react-assets -L;",
    "check:banjo": "scripts/checkForOrphanedBanjoStrings.mjs",
    "get-random-open-port": "node scripts/getRandomOpenPort.mjs",
    "ladle:serve": "ladle serve",
    "ladle:screenshot": "npx playwright test --config=playwright/scripts/ladle-screenshots.config.ts",
    "ladle:build": "ladle build",
    "render:feature-discovery": "NODE_PATH=src ts-node --compiler-options '{\"module\":\"CommonJS\",\"isolatedModules\":false}' scripts/renderFeatureDiscovery.ts",
    "render:feature-plan": "NODE_PATH=src ts-node --compiler-options '{\"module\":\"CommonJS\",\"isolatedModules\":false}' scripts/renderFeaturePlan.ts",
    "check:feature-contract": "NODE_PATH=src ts-node --compiler-options '{\"module\":\"CommonJS\",\"isolatedModules\":false}' scripts/checkFeatureContract.ts",
    "check:discovery": "NODE_PATH=src ts-node --compiler-options '{\"module\":\"CommonJS\",\"isolatedModules\":false}' scripts/checkFeatureDiscovery.ts",
    "check:kmp-drift": "NODE_PATH=src ts-node --compiler-options '{\"module\":\"CommonJS\",\"isolatedModules\":false}' scripts/checkKmpDrift.ts",
    "new:feature": "ts-node --compiler-options '{\"module\":\"CommonJS\"}' scripts/newFeature.ts",
    "typecheck": "tsc --noEmit -p tsconfig.json",
    "verify:feature": "NODE_PATH=src ts-node --compiler-options '{\"module\":\"CommonJS\",\"isolatedModules\":false}' scripts/verifyFeature.ts",
    "verify:feature-style": "playwright test --config=playwright/scripts/feature-style-parity.config.ts"
  },
  "dependencies": {
    "@18f/us-federal-holidays": "4.0.0",
    "@atomicfi/transact-javascript": "^3.0.0",
    "@braze/web-sdk": "^6.7.1",
    "@butchmayhew/playwright-json-summary-reporter": "^1.1.1",
    "@faker-js/faker": "^10.6.0",
    "@segment/analytics-next": "^1.76.0",
    "@stashinvest/product-events-typescript": "2.48.0",
    "@stashinvest/react-assets": "^2.0.3",
    "@stashinvest/react-banjo": "^1.14.0",
    "@stashinvest/react-components": "^0.86.3",
    "@stashinvest/shared-features-web": "^1.1.6",
    "@stashinvest/ui": "^3.19.2",
    "@stashinvest/use-fetch": "^2.8.0",
    "@testing-library/jest-dom": "^5.16.5",
    "@testing-library/user-event": "^13.5.0",
    "@types/jest": "^30.0.0",
    "@types/node": "^22.7.4",
    "@types/react": "^18.3.11",
    "@types/react-dom": "^18.3.0",
    "@types/react-router-dom": "^5.3.3",
    "@use-gesture/react": "^10.3.1",
    "body-parser": "^2.4.0",
    "classnames": "^2.5.1",
    "compression": "^1.8.1",
    "connected-react-router": "^6.9.1",
    "cookie-parser": "^1.4.7",
    "cors": "^2.8.5",
    "d3": "^7.2.1",
    "date-fns": "^2.14.0",
    "dd-trace": "^5.100.0",
    "dotenv": "^10.0.0",
    "express": "^4.20.0",
    "formik": "^2.1.4",
    "helmet": "^4.6.0",
    "http-proxy-middleware": "^4.2.0",
    "image-capture": "^0.4.0",
    "immer": "^9.0.6",
    "jest": "^30.4.0",
    "jsbarcode": "^3.11.5",
    "just-map-values": "^1.1.0",
    "launchdarkly-react-client-sdk": "^3.6.1",
    "lint-staged": "^11.2.6",
    "lodash": "^4.18.1",
    "nocache": "^3.0.1",
    "node-fetch": "^3",
    "open": "^8.2.0",
    "pkce-challenge": "^3.0.0",
    "playwright-merge-summary-json-reports": "^1.0.4",
    "prettier": "^2.3.1",
    "prop-types": "^15.7.2",
    "qrcode.react": "^3.1.0",
    "query-string": "^7.0.1",
    "react": "^18.3.1",
    "react-container-dimensions": "^1.4.1",
    "react-dom": "^18.3.1",
    "react-helmet": "^6.1.0",
    "react-hook-form": "^7.76.1",
    "react-lottie": "^1.2.10",
    "react-markdown": "^6.0.3",
    "react-plaid-link": "^3.5.1",
    "react-redux": "^7.2.6",
    "react-router": "^5.2.0",
    "react-router-dom": "^5.2.0",
    "react-share": "^4.2.0",
    "react-slick": "^0.30.3",
    "react-transition-group": "^4.4.1",
    "recharts": "^3.8.1",
    "redux": "^4.1.2",
    "redux-devtools-extension": "^2.13.8",
    "reselect": "^5.2.0",
    "selfsigned": "^5.5.0",
    "slick-carousel": "^1.8.1",
    "source-map-explorer": "^2.5.3",
    "stable-hash": "^0.0.6",
    "styled-components": "^5.3.3",
    "styled-system": "^5.1.5",
    "ts-node": "^10.9.2",
    "use-media": "^1.5.0",
    "yup": "^0.32.11"
  },
  "lint-staged": {
    "src/**/*.{js,jsx,ts,tsx}": [
      "eslint --quiet"
    ],
    "src/**/*.{js,jsx,json,css}": [
      "prettier --write"
    ],
    "*.{png,jpeg,jpg,svg}": [
      "node ./bin/minify-images.mjs"
    ]
  },
  "devDependencies": {
    "@babel/helper-call-delegate": "^7.10.1",
    "@babel/plugin-proposal-private-property-in-object": "^7.21.11",
    "@babel/preset-env": "^7.23.3",
    "@babel/preset-react": "^7.23.3",
    "@babel/preset-typescript": "^7.23.3",
    "@babel/runtime": "^7.29.7",
    "@datadog/browser-rum": "^7.16.0",
    "@datadog/datadog-ci": "^5.5.0",
    "@ladle/react": "^5.1.1",
    "@playwright/test": "^1.56.0",
    "@stashinvest/commitlint-config": "^2.0.1",
    "@stashinvest/husky-scripts": "^2.1.1",
    "@stashinvest/lint-staged-config": "^3.1.0",
    "@stashinvest/prettier-config": "^2.0.3",
    "@stashinvest/tailwind": "^0.74.3",
    "@testing-library/react": "^14.3.1",
    "@types/d3": "^7.4.3",
    "@types/react-helmet": "^6.1.11",
    "@types/react-slick": "^0.23.13",
    "@types/react-transition-group": "^4.4.12",
    "@types/styled-components": "^5.1.34",
    "@typescript-eslint/eslint-plugin": "^8.15.0",
    "@typescript-eslint/parser": "^8.15.0",
    "@vitejs/plugin-basic-ssl": "^2.3.0",
    "@vitejs/plugin-react": "^6.0.0",
    "babel-jest": "^30.4.0",
    "babel-plugin-macros": "^3.1.0",
    "camelcase": "^5.3.1",
    "concurrently": "^9.2.1",
    "eslint": "^8.57.0",
    "eslint-plugin-jsx-a11y": "^6.10.2",
    "eslint-plugin-react": "^7.28.0",
    "eslint-plugin-react-hooks": "^4.6.2",
    "eslint-plugin-testing-library": "^5.10.2",
    "husky": "^7.0.4",
    "imagemin": "^9.0.1",
    "imagemin-jpegtran": "^8.0.0",
    "imagemin-optipng": "^8.0.0",
    "imagemin-svgo": "^12.0.0",
    "istanbul-lib-coverage": "^3.0.0",
    "jest-canvas-mock": "^2.2.0",
    "jest-environment-jsdom": "^30.4.0",
    "jest-slow-test-reporter": "^1.0.0",
    "jest-styled-components": "^7.0.8",
    "jest-watch-typeahead": "^3.0.0",
    "nyc": "^15.1.0",
    "pixelmatch": "^7.2.0",
    "playwright-json-summary-reporter": "^1.0.1",
    "pngjs": "^7.0.0",
    "react-router-test-context": "^0.1.0",
    "react-test-renderer": "^18.3.1",
    "regenerator-runtime": "^0.14.1",
    "tailwindcss": "^3.2.4",
    "typescript": "^5.6.2",
    "uuidv4": "^6.2.13",
    "vite": "^8.1.5",
    "vite-plugin-svgr": "^5.2.0",
    "wait-port": "^1.1.0",
    "whatwg-fetch": "^3.6.20"
  },
  "resolutions": {
    "@types/react": "18.3.28",
    "@types/react-dom": "18.3.7",
    "axios": "^1.19.0",
    "brace-expansion": "1.1.12",
    "diff": "^4.0.4",
    "lodash": "^4.18.1",
    "lodash-es": "^4.18.1",
    "node-forge": "^1.3.2",
    "on-headers": "^1.1.0",
    "form-data": "^4.0.4",
    "cross-spawn": "^7.0.5",
    "cacheable-request/http-cache-semantics": "3.8.1",
    "http-cache-semantics": "^4.1.1",
    "http-proxy-middleware": "^2.0.7",
    "nth-check": "^2.0.1",
    "react-router/path-to-regexp": "1.9.0",
    "qs": "^6.14.2",
    "fast-xml-parser": "^5.3.6",
    "semver-regex": "^3.1.3",
    "simple-git": "^3.32.3",
    "tmp": "^0.2.4",
    "trim-newlines": "^3.0.1",
    "ws": "^8.17.1",
    "tar": ">=7.5.8",
    "js-yaml": "^4.1.1",
    "nyc/@istanbuljs/load-nyc-config/js-yaml": "3.14.2"
  },
  "babelMacros": {
    "styledComponents": {
      "pure": true
    }
  }
}
